import React from 'react';
import {
	Card, Row, Col, Input, Button, Table, Modal, Form,
	message, Tag, Tooltip, Typography, Pagination,
} from 'antd';
import {
	SearchOutlined, CheckCircleOutlined, CloseSquareOutlined,
	ExclamationCircleOutlined, RedoOutlined,
	CalendarOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title: 'Validasi Slip Setoran SWDKLLJ',
	apiUrl: { data: 'transaksi/api/validasi/' },
};

const config = new Config();

const formatRp = (val) => {
	if (val === undefined || val === null) return '—';
	const n = typeof val === 'number' ? val : Number(val);
	if (isNaN(n)) return String(val);
	return 'Rp ' + n.toLocaleString('id-ID');
};

const STATUS_VALIDASI = {
	true:  { label: 'Sudah Validasi', bg: '#f6ffed', border: '#b7eb8f', color: '#389e0d', icon: <CheckCircleOutlined /> },
	false: { label: 'Belum Validasi', bg: '#fff1f0', border: '#ffa39e', color: '#cf1322', icon: <CloseSquareOutlined /> },
};

const ValidasiTag = ({ value }) => {
	const k = (value === true || value === 'true') ? 'true' : 'false';
	const s = STATUS_VALIDASI[k];
	return (
		<Tag icon={s.icon} style={{
			borderRadius: 20, fontWeight: 700, fontSize: 12,
			background: s.bg, borderColor: s.border, color: s.color,
			padding: '2px 10px', display: 'inline-flex', alignItems: 'center', gap: 4,
		}}>
			{s.label}
		</Tag>
	);
};

class ValidasiSetoran extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			errMsg:      '',
			errTitle:    '',
			loadingData: false,
			pagination:  { current: 1, pageSize: 25, total: 0 },
			dataSource:  [],
			searchText:  '',
			isMobile:    window.innerWidth <= 768,
		};
		this._searchTimer = null;
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		this.getData();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
		clearTimeout(this._searchTimer);
	}

	_buildParams(page = 1) {
		const { pagination, searchText } = this.state;
		const limit = pagination.pageSize;
		const offset = (page - 1) * limit;
		let q = `?limit=${limit}&offset=${offset}`;
		if (searchText) q += `&search=${encodeURIComponent(searchText)}`;
		return q;
	}

	async getData(page = 1) {
		this.setState({ loadingData: true, errTitle: '', errMsg: '' });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + this._buildParams(page))
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState(prev => ({
						dataSource: data.results || [],
						pagination: { ...prev.pagination, current: page, total: data.count || 0 },
					}));
				} else {
					this.setState({ errTitle: 'Gagal memuat data', errMsg: this.props.responseMsg });
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
				this.setState({ loadingData: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
				this.setState({ loadingData: false });
			});
	}

	showValidasi(item) {
		Modal.confirm({
			title: 'Konfirmasi Validasi Slip Setoran',
			icon: <ExclamationCircleOutlined />,
			content: (
				<div>
					Yakin nilai SWDKLLJ telah BENAR{' '}
					<b style={{ color: '#cf1322' }}>{formatRp(item.jumlah_swdkllj)}</b>{' '}
					dan akan melakukan VALIDASI SLIP SETORAN SWDKLLJ tanggal:{' '}
					<b>{item.tgl_transaksi}</b>?
				</div>
			),
			okText: 'Ya, Validasi', okType: 'primary', cancelText: 'Batal',
			onOk: () => this.prosesValidasi(item),
		});
	}

	showBatalValidasi(item) {
		Modal.confirm({
			title: 'Konfirmasi Batal Validasi',
			icon: <ExclamationCircleOutlined />,
			content: (
				<div>
					Yakin akan membatalkan validasi slip setoran TGL{' '}
					<b style={{ color: '#cf1322' }}>{item.tgl_transaksi}</b>{' '}
					dengan total{' '}
					<b style={{ color: '#cf1322' }}>{formatRp(item.jumlah_swdkllj)}</b>?
				</div>
			),
			okText: 'Ya, Batalkan', okType: 'danger', cancelText: 'Tidak',
			onOk: () => this.prosesBatalValidasi(item),
		});
	}

	prosesValidasi(item) {
		message.loading({ content: 'Memproses validasi...', key: 'toast' });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + item.id + '/validasi_slip')
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Berhasil validasi slip setoran', duration: 2, key: 'toast' });
					this.getData(this.state.pagination.current);
				} else {
					message.error({ content: 'Gagal validasi slip setoran', duration: 2, key: 'toast' });
					this.setState({ errTitle: 'Gagal validasi', errMsg: this.props.responseMsg });
				}
			})
			.catch(() => message.error({ content: 'Gagal validasi, coba lagi', duration: 2, key: 'toast' }));
	}

	prosesBatalValidasi(item) {
		message.loading({ content: 'Memproses pembatalan...', key: 'toast' });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + item.id + '/batal_slip')
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Berhasil membatalkan validasi slip setoran', duration: 2, key: 'toast' });
					this.getData(this.state.pagination.current);
				} else {
					message.error({ content: 'Gagal membatalkan validasi', duration: 2, key: 'toast' });
					this.setState({ errTitle: 'Gagal batal validasi', errMsg: this.props.responseMsg });
				}
			})
			.catch(() => message.error({ content: 'Gagal membatalkan, coba lagi', duration: 2, key: 'toast' }));
	}

	handleFilter = () => this.getData(1);

	handleReset = () => {
		this.setState({ searchText: '' }, () => this.getData(1));
		if (this.formRef.current) this.formRef.current.resetFields();
	};

	handleSearchChange = (e) => {
		const val = e.target.value;
		this.setState({ searchText: val });
		clearTimeout(this._searchTimer);
		this._searchTimer = setTimeout(() => this.getData(1), 400);
	};

	_buildColumns() {
		return [
			{
				title: 'Tanggal', dataIndex: 'tgl_transaksi', key: 'tgl_transaksi', width: 130,
				render: (v) => <Text style={{ fontSize: 12, color: '#555' }}>{v || '—'}</Text>,
			},
			{
				title: 'Pokok SWDKLLJ', dataIndex: 'pokok_swdkllj', key: 'pokok_swdkllj', width: 160, align: 'right',
				render: (v) => <Text style={{ fontFamily: 'monospace', fontSize: 12, color: '#1e4d8a', fontWeight: 600 }}>{formatRp(v)}</Text>,
			},
			{
				title: 'Denda SWDKLLJ', dataIndex: 'denda_swdkllj', key: 'denda_swdkllj', width: 160, align: 'right',
				render: (v) => <Text style={{ fontFamily: 'monospace', fontSize: 12, color: v > 0 ? '#cf1322' : '#595959', fontWeight: 600 }}>{formatRp(v)}</Text>,
			},
			{
				title: 'Jumlah SWDKLLJ', dataIndex: 'jumlah_swdkllj', key: 'jumlah_swdkllj', width: 165, align: 'right',
				render: (v) => <Text style={{ fontFamily: 'monospace', fontSize: 13, color: '#0f2847', fontWeight: 700 }}>{formatRp(v)}</Text>,
			},
			{
				title: 'Status', dataIndex: 'status_slipsetoran', key: 'status_slipsetoran', width: 175, align: 'center',
				render: (v) => <ValidasiTag value={v} />,
			},
			{
				title: 'Aksi', key: 'aksi', width: 160, fixed: 'right', align: 'center',
				render: (_, row) => (
					row.status_slipsetoran === false || row.status_slipsetoran === 'false'
					? (
						<Button size="small"
							style={{ borderRadius: 8, background: '#52c41a', border: 'none', color: '#fff', fontWeight: 600 }}
							onClick={() => this.showValidasi(row)}>
							<CheckCircleOutlined /> Validasi
						</Button>
					) : (
						<Button size="small" danger
							style={{ borderRadius: 8, fontWeight: 600 }}
							onClick={() => this.showBatalValidasi(row)}>
							<CloseSquareOutlined /> Batalkan
						</Button>
					)
				),
			},
		];
	}

	renderMobileCard(row) {
		const isValidated = row.status_slipsetoran === true || row.status_slipsetoran === 'true';
		return (
			<Card key={row.id || row.tgl_transaksi} style={{ borderRadius: 14, marginBottom: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: '1px solid #f0f0f0', overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>
				<div style={{ background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)', borderBottom: '1px solid #d0dff5', padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 12 }}>
					<div style={{ width: 40, height: 40, borderRadius: 10, flexShrink: 0, background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<CalendarOutlined style={{ color: '#fff', fontSize: 17 }} />
					</div>
					<div>
						<div style={{ fontWeight: 700, fontSize: 14, color: '#0f2847' }}>{row.tgl_transaksi || '—'}</div>
						<div style={{ marginTop: 4 }}><ValidasiTag value={row.status_slipsetoran} /></div>
					</div>
				</div>

				<div style={{ padding: '10px 14px' }}>
					<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 12px' }}>
						<div>
							<div style={{ fontSize: 10, color: '#999', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>Pokok SWDKLLJ</div>
							<div style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 700, color: '#1e4d8a' }}>{formatRp(row.pokok_swdkllj)}</div>
						</div>
						<div>
							<div style={{ fontSize: 10, color: '#999', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>Jumlah SWDKLLJ</div>
							<div style={{ fontFamily: 'monospace', fontSize: 13, fontWeight: 800, color: '#0f2847' }}>{formatRp(row.jumlah_swdkllj)}</div>
						</div>
						{row.denda_swdkllj > 0 && (
							<div>
								<div style={{ fontSize: 10, color: '#999', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>Denda SWDKLLJ</div>
								<div style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 700, color: '#cf1322' }}>{formatRp(row.denda_swdkllj)}</div>
							</div>
						)}
					</div>
				</div>

				<div style={{ padding: '8px 14px', background: '#f9fbff', borderTop: '1px solid #edf2f9', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
					{!isValidated ? (
						<Button size="small"
							style={{ borderRadius: 8, background: '#52c41a', border: 'none', color: '#fff', fontWeight: 600 }}
							onClick={() => this.showValidasi(row)}>
							<CheckCircleOutlined /> Validasi
						</Button>
					) : (
						<Button size="small" danger style={{ borderRadius: 8, fontWeight: 600 }}
							onClick={() => this.showBatalValidasi(row)}>
							<CloseSquareOutlined /> Batalkan
						</Button>
					)}
				</div>
			</Card>
		);
	}

	render() {
		const { errMsg, errTitle, loadingData, dataSource, pagination, isMobile, searchText } = this.state;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.vs-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700; font-size: 12px; color: #0f2847;
							border-bottom: 2px solid #d0dff5;
						}
						.vs-wrap .ant-table-tbody > tr > td { padding: 10px 14px; vertical-align: middle; }
						.vs-wrap .ant-table-tbody > tr:hover > td { background: #e8f0fb !important; }
						.vs-wrap .ant-table-tbody > tr:nth-child(even) > td { background: #fafafa; }
						.vs-wrap .ant-table-tbody > tr:nth-child(even):hover > td { background: #e8f0fb !important; }
						.vs-wrap .ant-form-item-label > label { font-weight: 600; color: #374151; font-size: 12px; }
						.vs-wrap .ant-input { border-radius: 8px !important; }
					`}</style>
				</Helmet>

				<ErrorAlertModal visible={errMsg !== ''} title={errTitle} error={errMsg} onClose={() => this.setState({ errTitle: '', errMsg: '' })} />

				<Card className="vs-wrap" style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>

					{/* Header */}
					<div style={{ padding: '16px 20px', background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
								<CheckCircleOutlined style={{ marginRight: 8 }} />{configClass.title}
							</div>
							<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
								Total {pagination.total || 0} record{loadingData && ' · Memuat...'}
							</div>
						</div>
						<Tooltip title="Refresh">
							<Button icon={<RedoOutlined />} onClick={() => this.getData(pagination.current)}
								style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}>
								{!isMobile && 'Refresh'}
							</Button>
						</Tooltip>
					</div>

					{/* Filter */}
					<div style={{ padding: '14px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff' }}>
						<Form ref={this.formRef} layout="vertical" onFinish={this.handleFilter}>
							<Row gutter={[12, 0]} align="bottom">
								<Col xs={24} sm={16} lg={18}>
									<Form.Item label="Pencarian" style={{ marginBottom: 0 }}>
										<Input
											placeholder="Ketikkan pencarian..."
											prefix={<SearchOutlined style={{ color: '#bbb' }} />}
											allowClear
											style={{ borderRadius: 8 }}
											value={searchText}
											onChange={this.handleSearchChange}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={8} lg={6}>
									<Form.Item style={{ marginBottom: 0 }}>
										<div style={{ display: 'flex', gap: 8, justifyContent: isMobile ? 'stretch' : 'flex-end', marginTop: isMobile ? 8 : 0 }}>
											<Button onClick={this.handleReset} style={{ borderRadius: 8, flex: isMobile ? 1 : 'unset' }}>Reset</Button>
											<Button type="primary" icon={<SearchOutlined />} htmlType="submit" loading={loadingData}
												style={{ background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', border: 'none', borderRadius: 8, fontWeight: 600, flex: isMobile ? 1 : 'unset' }}>
												Filter
											</Button>
										</div>
									</Form.Item>
								</Col>
							</Row>
						</Form>
					</div>

					{/* Info bar */}
					<div style={{ padding: '8px 20px', borderBottom: '1px solid #f0f0f0', background: '#fafcff' }}>
						<Text type="secondary" style={{ fontSize: 12 }}>
							{loadingData ? 'Memuat data...' : `Menampilkan ${dataSource.length} dari ${pagination.total || 0} data`}
						</Text>
					</div>

					{/* Konten */}
					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							<div>
								{loadingData
									? <div style={{ textAlign: 'center', padding: 48, color: '#aaa' }}>Memuat data...</div>
									: dataSource.length === 0
										? <div style={{ textAlign: 'center', padding: 48, color: '#aaa' }}>Tidak ada data</div>
										: dataSource.map(row => this.renderMobileCard(row))
								}
								{pagination.total > 0 && (
									<div style={{ textAlign: 'center', padding: '12px 0 4px' }}>
										<Pagination
											current={pagination.current} pageSize={pagination.pageSize} total={pagination.total}
											onChange={(page) => this.getData(page)} showSizeChanger={false} simple
										/>
									</div>
								)}
							</div>
						) : (
							<Table
								columns={this._buildColumns()}
								dataSource={dataSource}
								loading={loadingData}
								rowKey={(row, i) => row.id || i}
								scroll={{ x: 'max-content' }}
								size="middle"
								pagination={{
									current: pagination.current,
									pageSize: pagination.pageSize,
									total: pagination.total,
									showSizeChanger: true,
									pageSizeOptions: ['10', '25', '50', '100'],
									showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
									onChange: (page, pageSize) => {
										this.setState(prev => ({ pagination: { ...prev.pagination, pageSize } }), () => this.getData(page));
									},
								}}
							/>
						)}
					</div>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;
export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler })(ValidasiSetoran);
